import React, { useState, useEffect } from "react"

import { Form } from "react-bootstrap"
import $ from "jquery"
import InputField from './elements/input'
import SelectField from './elements/select'
import TextAreaField from './elements/textarea'
import CheckboxField from './elements/checkbox'
import RadioField from './elements/radio'
import ButtonField from './elements/button'
import HtmlBox from './elements/html'
import ReCaptchaBox from './elements/recaptcha'
import { postFormData, nameValidation, emailValidation } from "./api/Api"
import axios from "axios"
import * as qs from "query-string"
import _ from "lodash";
import { getUser } from "@starberry/myaccount-website-utils"

function ShareFrndForm(props) {

  const userData = getUser();
  const [validated, setValidated] = useState(false);
  const [showerror, setShowerror] = useState(false);
  const [showthankyou, setThankyou] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [formvalues, setFormvalues] = useState("");

  const [token, setToken] = useState("");

  const myRef = React.createRef();

  const recaptchaRef = React.createRef();

  const fields = ([
      {
        element: "config",
        formname: "Send to Friend",
        error_text: "Highlighted fields are required",
        success_text: "Thank you for contacting us. A member of our team will contact you shortly.",
        email_temp_user: "send_to_friend_user",
        email_temp_admin: "send_to_friend_admin",
        email_subject_user:"Send to a friend",
        email_subject_admin:"Send to a friend",  
        email_server_func: "send_to_friend",
        event_tracking: "send_to_friend",
        page_url: "/general-enquiry"
      },      
      {
        grpmd: "12",
        label: "Name",
        placeholder: "Your Name",
        name: "name",
        type: "text",
        element: "input",
        class:"form__field",
        required: true,
        patternchk: "^[-a-zA-Z0-9-()]+(\\s+[-a-zA-Z0-9-()]+)*$",
        labelClass: "content_b-18",
        defaultValue: userData?.name || ``
      },
      {
        grpmd: "12",
        label: "Email",
        placeholder: "Your Email Address",
        name: "email",
        type: "email",
        element: "input",
        class:"form__field",
        required: true,
        patternchk:"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
        labelClass: "content_b-18",
        defaultValue: userData?.email || ``
      },
      {
        grpmd: "6",
        label: "Friend's Name",
        placeholder: "Your Friend's name",
        name: "friendname",
        class:"form__field",
        type: "text",
        element: "input",
        required: true,
        patternchk: "^[-a-zA-Z0-9-()]+(\\s+[-a-zA-Z0-9-()]+)*$"
      },
      {
        grpmd: "6",
        label: "Friend's Email",
        placeholder: "Your Friend's Email",
        name: "friendemail",
        class:"form__field",
        type: "email",
        element: "input",
        required: true,
        patternchk:"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"
      },
      {
        grpmd: "12",
        label: "Message",
        placeholder: "Write your message here...",
        name: "message",
        class: "form__field form__field-textarea",
        element: "textarea",
        rows:"5",
        labelClass: "content_b-18"
      },   
     
      {
        grpmd: "12",
        name: "SEND",
        type:"submit",
        element: "button",
        value: "submit",
        class: "btn btn--fill-darkblue",
        labelClass: "content_b-18"
      },      
      {
        element: "captcha",
        class: "py-2",
        captchaRef: recaptchaRef
      },
    ]);

  const handlechange = event => {
    // remove initial empty spaces
    event.target.value = event.target.value.trimStart()
  }

  useEffect(() => {
    if (token !== '') {

 const processFromData = async () => {

      formvalues['g-recaptcha-response'] = token;

      let formData = new FormData();
      // formvalues['extra'] = JSON.stringify({
      //   message: formvalues.message,
      //   name: formvalues.name
      // });
      formvalues['name'] = formvalues.name;
      formvalues['my_email'] = formvalues.email;
      formvalues['email'] = formvalues.friendemail;
      formvalues['email_subject_user'] = fields[0].email_subject_user;
      formvalues['email_subject_admin'] = fields[0].email_subject_admin;
      formData.append('data', JSON.stringify(formvalues));

      postFormData(formData).then(async apiRes => {
        window.grecaptcha.reset()
        await window.fetch(`${process.env.GATSBY_CLOUD_URL}/api/form`, {
          method: `POST`,
          mode: "no-cors",
          headers: {
            'Access-Control-Allow-Origin': '*',
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: qs.stringify(formvalues),
        })
      });

    
      // tracking event
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'formSubmit',
        'formType': 'form-'+fields[0].event_tracking,
        'formId': 'form-'+fields[0].event_tracking,
        'formName': fields[0].formname,
        'formLabel': fields[0].formname
      });

      setShowerror(false);
      setThankyou(true);
      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })

      }
      processFromData();

    }
  }, [token]);

  const handleonVerify = token => {
    console.log("captcha verified");
    setToken(token);
  };

  const stopSubmission = (event, elementid, errormsg) => {
    if (errormsg) {
      setErrorMessage(errormsg);
    }
    event.preventDefault();
    event.stopPropagation();
    setShowerror(true);
    setValidated(true);
    setThankyou(false);
    if (elementid) {
      const element = document.getElementById(elementid);
      if (element) {
        element.focus();
        element.select();
      }
    }
    myRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  const handleSubmit = event => {

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      $(".form-group input").each(function () {
        if ($(this).is(":invalid")) {
          $(this).closest(".form-group").addClass("invalid--field");
        } else {
          $(this).closest(".form-group").removeClass("invalid--field");
        }
      })
      // event.preventDefault();
      // event.stopPropagation();
      // setShowerror(true);
      // setValidated(true);
      // setThankyou(false);
      // myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end', inline: "nearest" })
      stopSubmission(event);
    }
    else {

      const name = $("input[name='name']");
      const email = $("input[name='email']");
      if (name.val() !== "") {
        const fvalid = nameValidation(name.val());
        if (!fvalid.valid) {
          stopSubmission(event, "validationname", fvalid.message);
        } else if (email.val() !== "") {
          const evalid = emailValidation(email.val());
          if (!evalid.valid) {
            stopSubmission(event, "validationemail", evalid.message);
          } else {
            event.preventDefault();

            const formsdata = (event.target);
            const json = {}
            Object.keys(formsdata).map(key => (
              json[formsdata[key].name] = (formsdata[key].checked) ? 'yes' : formsdata[key].value
            ))
            json['email_temp_user'] = fields[0].email_temp_user;
            json['email_temp_admin'] = fields[0].email_temp_admin;
            json['formname'] = fields[0].formname;
            json['property_id'] = props.subject.property_id ? props.subject.property_id : '';
            json['property_url'] = props.subject.page_url ? props.subject.page_url : '';
            json['property_title'] = props.subject.property_title ? props.subject.property_title : '';
            json['property_list'] = props.subject.properties ? props.subject.properties : '';
            json['property_img'] = props.subject.property_img ? props.subject.property_img : '';
            json['property_address'] = props.subject.property_address ? props.subject.property_address : '';
            json['property_bedrooms'] = props.subject.property_bedrooms ? props.subject.property_bedrooms : '';
            json['property_bathrooms'] = props.subject.property_bathrooms ? props.subject.property_bathrooms : '';
            json['g-recaptcha-response'] = token;
            json['extra'] = _.omit(json, ["formname", "name", "email", "telephone"])

            setFormvalues(json);
            recaptchaRef.current.execute();
            setValidated(false);
            setErrorMessage('');
            // reset form
            const form = event.target
            form.reset();
          }
        }
      }
    }
  };

  return (
    <div className="form contact-form common_form_class stbform">

    <div className="form-wraps input-wraps">
    {errorMessage &&
      <div className="alert-error">
        <p>{errorMessage ? errorMessage : fields[0].error_text}</p>
      </div>
    }

    {showthankyou && <div className="alert-success">
      <p>{fields[0].success_text}</p>
    </div>}
    <div ref={myRef} />
      <Form className="contact-form form-w-label " name={fields[0].formname} action="/thank-you/" method="post" noValidate validated={validated} onSubmit={handleSubmit} data-netlify="true" netlify-honeypot="bot-field" data-netlify-recaptcha="true">
        
        <input type="hidden" name="form_name" value={fields[0].formname} />
        <input type="hidden" name="to_email_id" value={props.to_email_id} />
        <input type="hidden" name="bot-field" />
        {fields.map((field, index) => {
            if ( "input" === field.element ) {
              return (
                <InputField
                  name={field.name}
                  grpmd={field.grpmd}
                  ref={field.ref}
                  type={field.type}
                  label={field.label}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  labelClass={field.labelClass}
                  required={field.required}
                  key={`${field.element}~${index}`}
                  pattern={field.patternchk}
                  handlechange={handlechange}
                  defaultValue={field?.defaultValue}
                />
              );
            }
            if ("select" === field.element) {
              return (
                <SelectField
                  name={field.name}
                  grpmd={field.grpmd}
                  ref={field.ref}
                  required={field.required}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  values={field.values}
                  key={`${field.element}~${index}`}
                  handlechange={handlechange}
                  componentprops={props}
                />
              );
            }
            if ("textarea" === field.element) {
              return (
                <TextAreaField
                  label={field.label}
                  name={field.name}
                  grpmd={field.grpmd}
                  ref={field.ref}
                  rows={field.rows}
                  fieldClass={field.class}
                  labelClass={field.labelClass}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.element}~${index}`}
                  handlechange={handlechange}
                />
              );
            }
            if ("checkbox" === field.element) {
              return (
                <CheckboxField
                  name={field.name}
                  ref={field.ref}
                  value={field.value}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={handlechange}
                  label={field.label}
                />
              );
            }
            if ("radio" === field.element) {
              return (
                <RadioField
                  name={field.name}
                  ref={field.ref}
                  value={field.value}
                  fieldClass={field.class}
                  checked={field.checked}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={handlechange}
                  lastchild={field.lastchild}
                />
              );
            }

            if ("captcha" === field.element) {
              return (
                <ReCaptchaBox
                  fieldClass={field.class}
                  captRef={field.captchaRef}
                  key={`${field.element}~${index}`}
                  handleonVerify={handleonVerify}
                />
              );
            }
            if ("button" === field.element) {
              return (
                <ButtonField
                  name={field.name}
                  fieldClass={field.class}
                  type={field.type}
                  value={field.value}
                  key={`${field.element}~${index}`}
                />
              );
            }
          })
        }
      </Form>
      </div>
    </div>
  );
}


const ShareFrndFormPage = (props) => (
  <ShareFrndForm to_email_id={props.to_email_id} subject={props} />
)

export default ShareFrndFormPage
